import { Currency } from '@seapoint/server/enums';

export type SupportedCountryCurrency = Exclude<Currency, 'AUD' | 'USD' | 'MULTI_CURRENCY'>;

export const supportedCountryCurrencies: SupportedCountryCurrency[] = [Currency.EUR, Currency.GBP];
